/**
 * SidebarHeaderActions -- Shared icon-button group rendered in sidebar headers.
 *
 * Contains two actions: "Connect my Claude Code" (Plugs icon, FEAT-033) and the
 * Activation Drawer toggle (Sliders icon).  Owns its own `useState` for the
 * modal / drawer open/close lifecycle so that
 * host pages (ChatPage, CodeShellPage, AdminLayout) can mount this component
 * without threading drawer state through props.
 *
 * Usage:
 *   <SidebarHeaderActions />
 */

import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Plugs, Sliders } from '@phosphor-icons/react';
import { Tooltip } from '@/components/ui/Tooltip';
import { ActivationDrawer } from '@/features/chat/ActivationDrawer';
import { ConnectClaudeCodeModal } from '@/features/settings/apiKey/ConnectClaudeCodeModal';

export function SidebarHeaderActions() {
  const intl = useIntl();
  const [isActivationDrawerOpen, setActivationDrawerOpen] = useState(false);

  const [isConnectOpen, setConnectOpen] = useState(false);

  const label = intl.formatMessage({
    id: 'sidebar.header.activations',
    defaultMessage: 'Gestao de agentes e skills',
  });
  const connectLabel = intl.formatMessage({ id: 'sidebar.header.connectClaudeCode' });

  return (
    <>
      {/* FEAT-033: "Connect my Claude Code" (masked snippets + link to the API key page) */}
      <Tooltip content={connectLabel} position="bottom">
        <button
          type="button"
          onClick={() => setConnectOpen(true)}
          className="inline-flex items-center justify-center rounded-md p-1.5 text-text-tertiary hover:bg-bg-tertiary hover:text-text-primary transition-colors cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-focus"
          aria-label={connectLabel}
        >
          <Plugs size={18} aria-hidden="true" />
        </button>
      </Tooltip>

      <Tooltip content={label} position="bottom">
        <button
          type="button"
          onClick={() => setActivationDrawerOpen(true)}
          className="inline-flex items-center justify-center rounded-md p-1.5 text-text-tertiary hover:bg-bg-tertiary hover:text-text-primary transition-colors cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-focus"
          aria-label={label}
        >
          <Sliders size={18} />
        </button>
      </Tooltip>

      <ActivationDrawer
        isOpen={isActivationDrawerOpen}
        onClose={() => setActivationDrawerOpen(false)}
      />

      <ConnectClaudeCodeModal isOpen={isConnectOpen} onClose={() => setConnectOpen(false)} />
    </>
  );
}
